// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import i18n from 'app/common/i18n';
import Profile from 'app/profile/tabs/profile';
import DwellingsTable from 'app/dwellings/table';

import { updateUser } from '../redux';
import { list as fetchDwellings } from 'app/redux/modules/dwellings';
import { Query } from '../../common/Query';

const USER = `
  query USER($id : ID!) {
    user(id : $id ) {
      id
      uuid
      name
      deletedAt
      expireAt
      firstname
      phone
      email
      lastname
      company
      companyAddress
      type
      cvr
      feedToken
      dwellings {
        id
        active
        status
        location {
          address
        }
        size {
          rooms
          area
        }
        economy {
          rent
        }
        contact {
          contactName: name
          contactEmail: email
          contactPhone: phone
        }
        listingType
        createdAt
        updatedAt
        approvedAt
        expiresAt
        deactivatedAt
        deactivatedBy {
          name
          initials
        }
      }
    }
  }
`;

function serializer(values) {
  return values.map((value) => {
    return {
      node: value
    };
  });
}

const Root = styled('div')(({ theme }) => ({
  flexGrow: 1,
  width: '100%',
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
  backgroundColor: theme.palette.background.paper
}));

type Props = {
  row: { get: (string) => string },
  dwellings: mixed,
  id: string,
  updateUser: (string, mixed) => { type: string, payload: mixed },
  triggerFetch: boolean,
  fetchDwellings: () => void
};

type State = {
  tab: number
};

class UsersTableRowDetail extends React.Component<Props, State> {
  i18n: (string) => string;
  state: State = {
    tab: 0
  };

  componentDidMount() {
    if (this.props.triggerFetch) {
      this.props.fetchDwellings();
    }
  }

  handleChange = (event, tab) => {
    this.setState({ tab });
  };

  handleRequestProfileUpdate = async (data) => {
    const { type } = await this.props.updateUser(
      this.props.row.id || this.props.row.get('_id'),
      data
    );
    if (!/SUCCESS/.test(type)) {
      throw new Error();
    }
  };

  handleRequestDocumentation = async (data) => {
    console.log({ data });
  };

  render() {
    const { row: user, dwellings } = this.props;
    const { tab } = this.state;

    return (
      <Query query={USER} variables={{ id: user.id || user.get('_id') }}>
        {({ data, refetch }) => {
          const _user = data?.user;

          return (
            <Root>
              <AppBar position="static" color="default">
                <Tabs
                  value={tab}
                  onChange={this.handleChange}
                  indicatorColor="primary"
                  textColor="primary"
                  scrollButtons="auto"
                  variant="scrollable"
                >
                  <Tab
                    label={this.props.i18n('Dwellings (%d)', dwellings.size)}
                  />
                  <Tab label={this.props.i18n('Profile')} />
                </Tabs>
              </AppBar>

              {tab === 0 && (
                <DwellingsTable
                  admin={false}
                  data={serializer(_user.dwellings) || []}
                  order="asc"
                  orderBy="ADDRESS"
                />
              )}

              {tab === 1 && (
                <Profile
                  isAdmin
                  user={_user}
                  onRequestUpdate={this.handleRequestProfileUpdate}
                  onSetUserType={() => refetch()}
                  onRequestDocumentation={this.handleRequestDocumentation}
                />
              )}
            </Root>
          );
        }}
      </Query>
    );
  }
}

export default connect(
  ({ dwellings }, { row }) => ({
    triggerFetch: !dwellings.get('data').size,
    dwellings: dwellings
      .get('data')
      .filter((dwelling) => dwelling.get('user') === row.id)
  }),
  { updateUser, fetchDwellings }
)(i18n(UsersTableRowDetail));
